import apiClient from "./axiosConfig";

// Get batches list with search
export const getBatchesList = async (params = {}) => {
  try {
    const { search = '', page = 1, page_size = 10 } = params;
    const queryParams = new URLSearchParams();
    
    if (search) queryParams.append('search', search);
    if (page) queryParams.append('page', page);
    if (page_size) queryParams.append('page_size', page_size);
    
    const response = await apiClient.get(`/stock-management/batches/?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching batches:', error);
    throw error;
  }
};

// Get batch detail
export const getBatchDetail = async (batchId) => {
  try {
    const response = await apiClient.get(`/stock-management/batches/${batchId}/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching batch detail:', error);
    throw error;
  }
};

// Create new batch
export const createBatch = async (batchData) => {
  try {
    const payload = {
      invoice_number: batchData.invoiceNumber,
      amount: parseFloat(batchData.amount),
      quantity: parseInt(batchData.totalQuantity),
      vendor: parseInt(batchData.supplierId),
      description: batchData.description || ""
    };
    
    const response = await apiClient.post('/stock-management/batches/', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating batch:', error);
    throw error;
  }
};

// Update batch
export const updateBatch = async (batchId, batchData) => {
  try {
    const payload = {
      invoice_number: batchData.invoiceNumber,
      amount: parseFloat(batchData.amount),
      quantity: parseInt(batchData.totalQuantity),
      vendor: parseInt(batchData.supplierId),
      description: batchData.description || ""
    };
    
    const response = await apiClient.patch(`/stock-management/batches/${batchId}/`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating batch:', error);
    throw error;
  }
};

// Delete batch
export const deleteBatch = async (batchId) => {
  try {
    const response = await apiClient.delete(`/stock-management/batches/${batchId}/`);
    return response.data;
  } catch (error) {
    console.error('Error deleting batch:', error);
    throw error;
  }
};

// Get batch count and statistics
export const getBatchCount = async () => {
  try {
    const response = await apiClient.get('/stock-management/batches/count/');
    return response.data;
  } catch (error) {
    console.error('Error fetching batch count:', error);
    throw error;
  }
};